import {step1} from './state/step1';
import {step2} from './state/step2';
import {step3} from './state/step3';

export const initialState = { ...step1, ...step2, ...step3};